import React from "react";

import person1 from "../../assets/Persons/person1.png";
import person2 from "../../assets/Persons/person2.png";
import person3 from "../../assets/Persons/person3.png";
import person4 from "../../assets/Persons/person4.png";
import background from "../../assets/background.png";
// import { ReactComponent as DocumentsList } from "../../assets/documentsList.svg";
import { ReactComponent as SmalldocumentsList } from "../../assets/smalldocumentsList.svg";
import DocumentsList from "../../assets/documentList.png";

import AlbaniaFlag from "../../assets/flags/AlbaniaFlag.png";
import UAEFlag from "../../assets/flags/UAEFlag.png";
import ArmeniaFlag from "../../assets/flags/ArmeniaFlag.png";
import BangladeshFlag from "../../assets/flags/BangladeshFlag.png";
import BosniaFlag from "../../assets/flags/BosniaFlag.png";
import BulgariaFlag from "../../assets/flags/BulgariaFlag.png";
import MyanmarFlag from "../../assets/flags/MyanmarFlag.png";
import SpainFlag from "../../assets/flags/SpainFlag.png";
import ChinaFlag from "../../assets/flags/ChinaFlag.png";
import CreoleFlag from "../../assets/flags/CreoleFlag.png";
import USAFlag from "../../assets/flags/USAFlag.png";
import iranFlag from "../../assets/flags/iranFlag.png";
import finlandFlag from "../../assets/flags/finlandFlag.png";
import franceFlag from "../../assets/flags/franceFlag.png";
import canadaFlag from "../../assets/flags/canadaFlag.png";
import georgiaFlag from "../../assets/flags/georgiaFlag.png";
import germanyFlag from "../../assets/flags/germanyFlag.png";
import GreekFlag from "../../assets/flags/GreekFlag.png";
import IndianFlag from "../../assets/flags/IndianFlag.png";
import israelFlag from "../../assets/flags/israelFlag.png";
const Languages = ({ showMostPopularDocuments = true }) => {
  const LanguageData = [
    { flag: AlbaniaFlag, language: "Albanian" },
    { flag: USAFlag, language: "English" },
    { flag: UAEFlag, language: "Arabic" },
    { flag: iranFlag, language: "Farsi" },
    { flag: ArmeniaFlag, language: "Armenian" },
    { flag: finlandFlag, language: "Finnish" },
    { flag: BangladeshFlag, language: "Bengali" },
    { flag: franceFlag, language: "French" },
    { flag: BosniaFlag, language: "Bosnian" },
    { flag: canadaFlag, language: "French (Canadian)" },
    { flag: BulgariaFlag, language: "Bulgarian" },
    { flag: georgiaFlag, language: "Georgian" },
    { flag: MyanmarFlag, language: "Burmese" },
    { flag: germanyFlag, language: "German" },
    { flag: SpainFlag, language: "Catalan" },
    { flag: GreekFlag, language: "Greek" },
    { flag: ChinaFlag, language: "Chinese (Simplified)" },
    { flag: IndianFlag, language: "Gujrati" },
    { flag: ChinaFlag, language: "Chinese (Traditional)" },
    { flag: israelFlag, language: "Hebrew" },
    { flag: CreoleFlag, language: "Catalan" },
    { flag: IndianFlag, language: "Hindi" },
  ];

  const PersonList = [
    {
      image: person1,
    },
    {
      image: person2,
    },
    {
      image: person3,
    },
    {
      image: person4,
    },
  ];


  return (
    <div className="pt-20" id="languages">
      <div className="space-y-8">
        <div className=" grid grid-cols-1 lg:grid-cols-2 gap-5">
          <div className="flex flex-col h-full justify-between lg:py-20 lg:px-8 p-4 gap-8">
            <h2 className="font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase text-left ">
              Translations in <br />
              <span className="text-primary">over 60+</span>
              <br /> languages
            </h2>
            <div className="flex flex-col gap-4">
              <div>
                <ul className="flex items-center">
                  {PersonList.map((person, index) => (
                    <li
                      key={index}
                      className="h-12 w-12 border-4 border-[#EFF3F5] rounded-full overflow-hidden -mr-3"
                    >
                      <img
                        src={person.image}
                        alt="person"
                        className="max-h-full max-w-full"
                      />
                    </li>
                  ))}
                </ul>
              </div>
              <p className="lg:text-tertiary text-[#686F7B] text-base text-left xl:w-1/2 w-full">
                We work with a team of highly qualified, full-time translators,
                ensuring consistent quality across every language we offer.
              </p>
            </div>
          </div>
          <div className="bg-white rounded-4xl overflow-hidden shadow-sm py-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:max-h-full max-h-[500px] md:overflow-hidden overflow-y-scroll px-8">
              {LanguageData.map((item, index) => (
                <div
                  key={index}
                  className="flex gap-3 items-center justify-between"
                >
                  <div className="flex gap-2 items-center">
                    <span className="text-xl">
                      <img
                        src={item.flag}
                        alt={item.flag}
                        className="h-6 w-6"
                      />
                    </span>
                    <span className="text-xl">{item.language}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

       { showMostPopularDocuments && <div
          style={{ backgroundImage: `url(${background})` }}
          className="overflow-hidden rounded-4xl bg-cover bg-center mt-5 space-y-8 "
        >
          <div className="flex flex-col gap-4 items-center md:p-8 p-4 mt-10">
            <h2 className="font-secondary font-medium md:text-5xl text-4xl text-white uppercase text-center ">
              Most Popular Documents
            </h2>
            <p className="text-[#BDC1C9] text-base text-center xl:w-[30%] md:w-1/2 w-full">
              The most popular documents for translation. Get your standard or
              certified translations quickly and accurately.
            </p>
          </div>

          <div className="w-full flex justify-center">
            <img
              src={DocumentsList}
              className="max-h-full max-w-full bg-no-repeat size-full sm:block hidden"
              alt=""
            />
            <SmalldocumentsList className="max-h-full max-w-full bg-no-repeat size-full sm:hidden block " />
          </div>
        </div>}
      </div>
    </div>
  );
};

export default Languages;
